var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-dialer-call-controls",
      class: ((_obj = {}), (_obj["is-" + _vm.size] = true), _obj),
    },
    [
      _vm.hasKeypadButton
        ? _c("base-icon-button", {
            attrs: {
              icon: "dialpad",
              "is-active": _vm.isKeypadActive,
              "is-disabled": _vm.isConnecting,
              size: _vm.size,
            },
            on: {
              click: function ($event) {
                return _vm.$emit("toggle-keypad", $event)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.hasInviteButton
        ? _c("base-icon-button", {
            attrs: {
              icon: "add",
              "is-active": _vm.isInviteButtonActive,
              "is-disabled": _vm.isConnecting,
              size: _vm.size,
            },
            on: {
              click: function ($event) {
                return _vm.$emit("toggle-invite", $event)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.hasTransferButton
        ? _c("base-icon-button", {
            attrs: {
              icon: "wrap_text",
              "is-active": _vm.isTransferButtonActive,
              "is-disabled": _vm.isConnecting,
              size: _vm.size,
            },
            on: {
              click: function ($event) {
                return _vm.$emit("toggle-transfer", $event)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.hasHoldButton
        ? _c("base-icon-button", {
            attrs: {
              icon: _vm.putOnHoldIcon,
              "is-active": _vm.isOnHold,
              "is-loading": _vm.isPutOnHoldActionLoading,
              "is-disabled":
                (_vm.isConnecting || !_vm.hasContactMemberOnCall) &&
                !_vm.isOnHold,
              size: _vm.size,
            },
            on: {
              click: function ($event) {
                return _vm.$emit("put-on-hold", $event)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.hasMuteButton
        ? _c("base-icon-button", {
            attrs: {
              icon: _vm.muteIcon,
              "is-active": _vm.isMuted,
              size: _vm.size,
            },
            on: {
              click: function ($event) {
                return _vm.$emit("mute-self", $event)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("base-icon-button", {
        attrs: {
          icon: "call_end",
          color: "error",
          "is-loading": _vm.isHangUpActionLoading,
          size: _vm.size,
        },
        on: {
          click: function ($event) {
            return _vm.$emit("hang-up", $event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }